/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, April 2020
 *
 *****************************************************************************/


import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

// custom material tooltip
const TextOnlyTooltip = withStyles({
  tooltip: {
    color: "white",
    backgroundColor: "#4e4e4e",
    fontSize: "12px",
  },
})(Tooltip);

export default TextOnlyTooltip;
